import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Launches from './components/Launches';
import Launch from './components/Launch';
import Rocket from './components/Rocket';
import Footer from './components/Footer';
import './App.css';
import logo from './assets/Spacex_3.png';

function App() {
    return (
        <Router>
                <div className="container">
                    <a href="/">
                        <img src={logo} alt="SpaceX" style={{ width: 600, display: 'flex', margin: 'auto' }} />
                    </a>
                    <Routes>
                        <Route path="/" element={<Launches />} />
                        <Route path="/launch/:id" element={<Launch />} />
                        <Route path="/rocket/:id" element={<Rocket />} />
                    </Routes>
                </div>
            <Footer />
        </Router>
    );
}

export default App;